import styled, { css } from 'styled-components';

import { fonts } from '@dreryk/react-components';

type StyledDiseaseItemProps = {
   $main: boolean;
};

export const StyledDiseaseItem = styled.div<StyledDiseaseItemProps>`
   display: flex;
   white-space: pre;

   ${(props) =>
      props.$main &&
      css`
         font-weight: ${fonts.fontWeightBold};
      `};

   :not(:last-child):after {
      content: ', ';
   }
`;

StyledDiseaseItem.displayName = 'StyledDiseaseItem';
